import { RouteType } from "types/routes.types";
import Login from "views/Login";
import NotFound from "views/NotFound";
import Redirect from "views/Login/Redirect";
import HealthCheck from "views/HealthCheck";

export const routes: RouteType[] = [
  {
    name: "login",
    path: "/login",
    Element: Login,
  },
  {
    name: "redirect",
    path: "/redirect",
    Element: Redirect,
    hideInMenu: true,
  },
  {
    name: "notFound",
    path: "*",
    Element: NotFound,
  },
  {
    name: "alive",
    path: "/alive",
    Element: HealthCheck,
  },
];
